export const yodaUtilsActions = {
  checkValue,
  validateCustomer,
  validateAgent,
  redirectOnMissingParam,
};

function checkValue(value) {
  if (
    value === "null" ||
    value === null ||
    value === "undefined" ||
    value === undefined ||
    value === "0" ||
    value === 0
  ) {
    return true;
  }

  return false;
}

function validateCustomer() {
  return localStorage.getItem("selectedCustomer") !== null;
}

function validateAgent() {
  return localStorage.getItem("selectedAgent") !== null;
}

function redirectOnMissingParam(queryName, params, callback) {
  if (params && Object.keys(params)?.length) {
    const errors = Object.entries(params).reduce((prev, [key, value]) => {
      const failed = checkValue(value);
      if (failed) {
        return {
          ...prev,
          [key]: JSON.stringify(value),
        };
      }
      return prev;
    }, {});
    if (Object.keys(errors)?.length) {
      console.log(
        `API error: ${queryName}`,
        JSON.stringify(errors, (key, value) =>
          typeof value === "undefined" ? "undefined" : value,
        ),
      );
      return () => {};
    } else {
      return callback();
    }
  } else {
    return callback();
  }
}
